import styled from '@emotion/styled'
const FixedBottom = styled.div<{ height?: string }>`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1;
`

export default FixedBottom
